import { ENDPOINTS } from '../constants/apiEndpoints';
import api from './api';

export const searchApi = (searchDto) => {
  const payload = {
    data: JSON.stringify(searchDto),
    target: "models.commons.Search",
    compressed: false
  };

  return api.post(ENDPOINTS.search.url, payload);
};